import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'create-factiva-select-source',
    template: `
        <mat-card [formGroup]="form">
            <mat-card-header>
                <h2>Create Factiva Select Source</h2>
            </mat-card-header>
            <mat-card-content style="padding: 25px;">
                <div fxLayout="column" style="height: 100%">
                    <mat-form-field fxFlex>
                        <input matInput placeholder="Title" formControlName="title">
                        <mat-error *ngIf="form.get('title').hasError('required')">Title is required.</mat-error>
                    </mat-form-field>
                    <mat-form-field fxFlex>
                        <input matInput placeholder="Factiva Customer ID" formControlName="customerId">
                        <mat-error *ngIf="form.get('customerId').hasError('required')">Factiva Customer ID is required.</mat-error>    
                    </mat-form-field>
                    <mat-form-field fxFlex>
                        <input matInput placeholder="Folder Name" formControlName="folderName">
                        <mat-error *ngIf="form.get('folderName').hasError('required')">Folder Name is required.</mat-error>    
                    </mat-form-field>
                    <mat-form-field fxFlex>
                        <input matInput placeholder="Password" formControlName="password">
                        <mat-error *ngIf="form.get('password').hasError('required')">Password is required.</mat-error>    
                    </mat-form-field>
                </div>
            </mat-card-content>
            <mat-card-actions>
                <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="saveStream()">Save</button>
            </mat-card-actions>
        </mat-card>
    `
})
export class CreateFactivaSelectSourceComponent {
    @Output() save = new EventEmitter<any>();
    form: FormGroup;
    
    constructor(fb: FormBuilder) {
        this.form = fb.group({
            title: ['', Validators.required],
            customerId: ['', Validators.required],
            folderName: ['', Validators.required],
            password: ['', Validators.required]
        });
    }

    saveStream(): void {
        this.save.emit({
            title: this.form.value.title,
            type: 'FACTIVA_SELECT_HTTP',
            settings: {
                uri: 'select.factiva.com/' + this.form.value.folderName,
                username: 'select/' + this.form.value.customerId,
                password: this.form.value.password,
                itemTimeToLiveInDays: 90
            }
        });
    }
}